import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import ButtonWithIcon from 'chameleon/packages/blue-book-player/library/button-with-icon';

const DragButton = forwardRef((props, ref) => {
  const { onKeyUp, onBlur, accessibility } = props;
  const buttonRef = useRef();
  const [isPressed, setIsPressed] = useState(false);
  //cursor-move focus:cursor-grabbing

  const toggleDraggingButton = () => {
    setIsPressed((currentIsPressed) => !currentIsPressed);
  };

  const onClick = useCallback((e) => {
    toggleDraggingButton();
    if (e.type === 'click') {
      onKeyUp(e);
    }
  }, []);

  useImperativeHandle(ref, () => ({
    setIsPressed: (newIsPressed) => {
      setIsPressed(newIsPressed);
    },
    isPressed: () => isPressed,
  }));

  useEffect(() => {
    buttonRef?.current?.focus();
  }, [buttonRef]);

  return (
    <>
      <ButtonWithIcon
        ref={buttonRef}
        isIcon
        isBlueBookIcon
        isInverted
        isPressed={isPressed}
        roundSize="small"
        iconWidth="34"
        iconHeight="28"
        className="focus:cursor-grabbing"
        accessibility={{
          'aria-pressed': isPressed,
          ...accessibility,
        }}
        icon="sixDots"
        data-cy="draggable-button"
        onClick={onClick}
        onKeyUp={onKeyUp}
        onBlur={onBlur}
      />
    </>
  );
});

export default DragButton;
